import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap';
import { CgClose } from 'react-icons/cg';
import { BsQuestionSquare } from 'react-icons/bs';
import "./ModalFormularioNuevaRequisicion.css";
import { estiloColorError, estiloComboBox, estilosModal } from '../../../Services/PaletaDeColores';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SpinnerModal from '../SpinnerModal/SpinnerModal';
import { Table } from 'reactstrap';

export default class ModalFormularioRanchosDisponibles extends React.Component {

    constructor(props) {
        super(props)
        
        this.state = {
            show: props.show,
            confirmarenvio: false,
            accion: props.accion, // 1 Nuevo, 2 editar
            titulo: props.titulomodal,

            estilosmodal: estilosModal(),
           

            listaranchosdisponibles: props.listaranchosdisponibles,
            listaranchosseleccionados: [],
            listaranchosagregados: this.props.zona.ranchos,
            listazonasduplicadas: [],


            tabla: {
                encabezados: [
                    "Selecciona una rancho"
                ],
                dimensiones: [
                    "15%"
                ],
                mindimensiones: [
                    "100px",
                ],
                elementos: [],
            },
        }

    }
    async componentDidMount() {

    }


    showModal = (mensaje) => {
        this.setState({ show: false });
        setTimeout(() => {
            this.props.cerrarModal(mensaje);
        }, 200);

    }

    escribir = (prop) => (event) => {
        this.setState({ [prop]: event.target.value });
    };


    continuarProceso = async () => {
        if(this.state.listaranchosseleccionados.length > 0){
            

            var ranchorepetido=false;
            var listaranchosrepetidos=[];
           
            this.state.listaranchosseleccionados.forEach(element => {
                var itemfound = this.state.listaranchosagregados.find(item => item.idrancho == element.idcatalogo_rancho);
                if(itemfound != undefined){
                    listaranchosrepetidos.push(element)
                    ranchorepetido = true; 
                }
            });
            if(!ranchorepetido){
                var listaranchosagregadosaux = []
                this.state.listaranchosseleccionados.forEach(element => {
                    var nuevorancho= {
                        idrancho: element.idcatalogo_rancho,
                        rancho: element.rancho,
                        eliminar: false,
                        lotes: []
                    }
                    listaranchosagregadosaux.push(nuevorancho);
                });
                
                this.showModal(listaranchosagregadosaux)
            }else{
                
                await this.setState({
                    listaranchosduplicadas: listaranchosrepetidos
                })
                toast.info("Los ranchos ya se encuentran agregados", { autoClose: 1000, position: toast.POSITION.TOP_LEFT });
            }
        }else{
            toast.info("Favor de seleccionar al menos un rancho", { autoClose: 1000, position: toast.POSITION.TOP_LEFT });
        }
    }


    seleccionarItem = async (itemseleccionado) => {
        var listaranchosseleccionadosaux = this.state.listaranchosseleccionados;
        var itemfound = listaranchosseleccionadosaux.find(item => item.idcatalogo_rancho == itemseleccionado.idcatalogo_rancho);

        if(itemfound == undefined){
            listaranchosseleccionadosaux.push(itemseleccionado)
        }else{
            var index = listaranchosseleccionadosaux.indexOf(itemseleccionado)
            if(index > -1){
                listaranchosseleccionadosaux.splice(index,1)
            }
        }
        await this.setState({
            listaranchosseleccionados: listaranchosseleccionadosaux,
            confirmarenvio: true
        })
    }

    render() {
        return (

            <>
              {(this.state.loadingspinners == true) ? (
                    <SpinnerModal tipo="full" show={this.state.loadingspinners} />
                ) : null}

                <Modal isOpen={this.state.show}
                    size="md"
                    aria-labelledby=""
                    centered>
                    <ModalBody>

                        <CgClose className='icoCloseModal' onClick={() => this.showModal([])} />
                        <label className="modalLblTitulo letraTitulos" style={{ Color: this.state.estilosmodal.colorlbltextomodal }} >{this.state.titulo}</label>

                        <br />
                        <br />
                        <div className="divCuerpoModal">

                        <div className="divContenedorModal" style={{ backgroundColor: this.state.estilosmodal.fondocontenedormodal }}>
                                {/* ////////////////////   Tabla   ////////////////////////////////////// */}

                                <br />
                                <div className="container-fluid containerTabla">
                                    <div className="container-fluid anchoMaximo ">
                                        <div className="containerSubTabla tablaMaxHeight">
                                            <Table hover>
                                                <thead style={{ verticalAlign: "bottom" }}>
                                                    <tr>
                                                        <th key={"tabla" + 1} className="lblEncabezadosTabla letraTitulos"
                                                                style={{ minWidth: this.state.tabla.mindimensiones[1], width: this.state.tabla.dimensiones[1], color: this.state.colorencabezadostabla }}>
                                                                Selecciona un rancho:
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody style={{ verticalAlign: "bottom" }}>
                                                    {
                                                        this.state.listaranchosdisponibles.length > 0 ?
                                                        this.state.listaranchosdisponibles.map((item, index) => (
                                                            (<tr key={"tabla" + index} onClick={() => this.seleccionarItem(item)} 
                                                            className={this.props.zona.ranchos.find(rancho => rancho.idrancho == item.idcatalogo_rancho) != undefined ? "trFondoInactivoGray" : this.state.listaranchosseleccionados.find(selected => selected.idcatalogo_rancho == item.idcatalogo_rancho) == undefined ? "" : "trFondoActivoGreen"}>
                                                                <td className="letraNormal lblSubtabla" style={{ color: this.state.colorcontenidotabla }}>
                                                                    {item.rancho}
                                                                </td>
                                                            </tr>)
                                                        )):<p>No hay ranchos disponibles para esta zona</p> 

                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        {this.state.accion == 2 || this.state.accion == 1 ? (
                            <>
                                <br />
                                <div className="divBtnContenedorModal" >
                                    <Button className="btnCancelModal" onClick={() => this.showModal([])}>Cancelar</Button>
                                    <Button className="btnAceptarModal" onClick={() => this.continuarProceso()}  disabled={!this.state.confirmarenvio}>Continuar</Button>
                                </div>
                            </>
                        ) : null}

                    </ModalBody>

                </Modal>
            </>
        )
    }

}

